// searchText — punctuation-insensitive search normalization (#86bb5dx62).
//
// NVR system/view names carry apostrophes and symbols ("Rosa's Cafe", "TG's", "Texas Burger #3"),
// so a raw substring match makes the obvious query "rosas" miss "Rosa's Cafe". Normalizing BOTH
// the query and the candidate — lowercase, strip diacritics, drop punctuation, collapse spaces —
// before the includes() test lets the intuitive query hit. Shared by the Views + Jump type-ahead.

// Lowercase, strip diacritics (cafe accents), drop punctuation (Rosa's -> rosas), single-space.
export const normalizeSearchText = (str) =>
  (str == null ? '' : str)
    .toString()
    .toLowerCase()
    .normalize('NFD').replace(/[̀-ͯ]/g, '') // accent-insensitive: cafe accents removed
    .replace(/[^a-z0-9\s]/g, '')                       // drop punctuation: rosa's #16 -> rosas 16
    .replace(/\s+/g, ' ')
    .trim();

// True when `query` matches `candidate` ignoring case, accents and punctuation. An empty query
// matches everything, so an empty search box shows the full list.
export const matchesSearch = (candidate, query) => {
  const q = normalizeSearchText(query);
  return !q || normalizeSearchText(candidate).includes(q);
};
